import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import predsedatelImg from '../assets/images/predsedatel.jpg';
import prezidentImg from '../assets/images/prezident.jpg';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  @media (max-width: 980px){ grid-template-columns: 1fr; }
`;

// ВАЖНО: используем $photoSide (transient-prop), чтобы не утекал в DOM
const Card = styled.article`
  border: 1px solid var(--bdr);
  border-radius: 14px;
  background: var(--card);
  padding: 16px;
  display: grid;
  gap: 14px;
  grid-template-columns: ${({ $photoSide }) => $photoSide === 'left' ? '220px 1fr' : '1fr 220px'};
  align-items: center;

  @media (max-width: 720px){
    grid-template-columns: 1fr;
  }
`;

const Head = styled.h3`margin: 0 0 10px; font-size: 18px;`;
const Quote = styled.p`margin: 0; color: var(--muted);`;

const Photo = styled.img`
  width: 100%;
  height: 220px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid var(--bdr);
`;

export default function ChairmanSection(){
  const { t } = useTranslation();

  return (
    <Grid>
      {/* Слева блок: Председатель (фото слева, текст справа) */}
      <Card $photoSide="left">
        <Photo
          src={predsedatelImg}
          alt="Chairman"
          loading="lazy"
          decoding="async"
        />
        <div>
          <Head>{t('home.chairmanChairman')}</Head>
          <Quote>«{t('home.chairmanQuote')}»</Quote>
        </div>
      </Card>

      {/* Справа блок: Президент (фото справа, текст слева) */}
      <Card $photoSide="right">
        <div>
          <Head>{t('home.chairmanPresident')}</Head>
          <Quote>«{t('home.presidentQuote')}»</Quote>
        </div>
        <Photo
          src={prezidentImg}
          alt="President"
          loading="lazy"
          decoding="async"
        />
      </Card>
    </Grid>
  );
}
